import { render, staticRenderFns } from "./accessControl.vue?vue&type=template&id=34ca6243&scoped=true"
import script from "./accessControl.vue?vue&type=script&lang=js"
export * from "./accessControl.vue?vue&type=script&lang=js"
import style0 from "./accessControl.vue?vue&type=style&index=0&id=34ca6243&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ca6243",
  null
  
)

export default component.exports